import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

import {
  AWS_TAG_KEY_REGEX,
  AZURE_TAG_KEY_REGEX,
  GCLOUD_TAG_KEY_REGEX,
} from "./types.ts";
import { isAwsId, isAzureId, isGcloudId } from "./util.ts";

export const SshComponents = InstallSpec({
  settings: ItemComponent({
    type: "singleton",
    label: "Integration settings",
    description: "Global settings for the SSH integration",
    maturity: "ga",
    hidden: true,
    schema: {
      awsCacheIntervalMs: Element({
        label: "Cache interval (ms)",
        description: "Interval for refreshing the AWS SSH instance cache",
        type: "string",
        optional: true,
        hidden: true,
      }),
      azureCacheIntervalMs: Element({
        label: "Cache interval (ms)",
        description: "Interval for refreshing the Azure SSH instance cache",
        type: "string",
        optional: true,
        hidden: true,
      }),
    },
  }),
  "iam-write": ItemComponent({
    type: "dynamic",
    label: "SSH access control",
    description: "Allows P0 to provide ssh access to compute instances",
    maturity: "ga",
    schema: {
      groupKey: Element({
        label: "Grouping tag (optional)",
        description:
          "If present, compute instances will be grouped by the value of this tag. Access can be requested, in one request, to all instances with a shared tag value.",
        type: "string",
        validator: async (id, field) => {
          if (isAwsId(id)) {
            if (!field.match(AWS_TAG_KEY_REGEX)) {
              return "Invalid AWS tag key. Expected a string of 1 to 128 characters";
            }
          }

          if (isGcloudId(id)) {
            if (!field.match(GCLOUD_TAG_KEY_REGEX)) {
              return "Invalid Google Cloud tag key. Tag keys must include a project or organization identifier followed by a key name of 1 to 256 characters without \" ' \\ /.  The project or og identifier and key name must be joined by a /";
            }
          }

          if (isAzureId(id)) {
            if (!field.match(AZURE_TAG_KEY_REGEX)) {
              return "Invalid Azure tag key. Tag keys cannot contain the characters <>%&\\?/ and must be 512 characters or less";
            }
          }
        },
      }),
      isSudoEnabled: Element({
        label: "Enable sudo access requests",
        description:
          "If enabled the integration will provide sudo access to the instances",
        type: "switch",
      }),
      networkAccessProvider: Element({
        label: "Network-access provider",
        description: "The provider to use for network access",
        type: "dynamic",
        maxItems: 1,
      }),
    },
  }),
});
